export default {
  haulers: 'Wozi',
  setup: 'Organizować coś',
  driverExperience: 'Doświadczenie kierowcy',
  users: 'Użytkownicy',
};
